"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUISettingField = useUISettingField;
var _SettingsContext = require("../../SettingsContext");
var _react = require("react");
var _useUISettingPage = require("./useUISettingPage");
function useUISettingField(fieldId) {
  var page = (0, _useUISettingPage.useUISettingPage)();
  var field = (0, _react.useMemo)(function () {
    return page.fields.find(function (f) {
      return f.id === fieldId;
    });
  }, [fieldId, page.fields]);
  if (!field) {
    throw new _SettingsContext.UISettingsError("There is no field ".concat(fieldId, " specified in the ").concat(page.id, " page in the UI settings"));
  }
  return field;
}